import { Divider, Stack } from "@mui/material";

import { useGetAllProducts } from "../../api/products";
import CreateProductButton from "../../components/molecules/CreateProductButton";
import GenerateReportButton from "../../components/molecules/GenerateReportButton";
import InventoryDataGrid from "../../components/organisms/inventoryDataGrid/InventoryDataGrid";
import ProductFilters from "../../components/organisms/productFilters/ProductFilters";
import StatusCounter from "../../components/organisms/StatusCounter";
import { useFilterQuery } from "../../stores/filterStore";

const RewardsInventory = () => {
  const { queryString } = useFilterQuery();
  const { data: filteredData, isFetching } = useGetAllProducts(queryString);

  return (
    <Stack spacing={2} mt={2}>
      <Stack
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        px={5}
      >
        <StatusCounter />
        <GenerateReportButton />
      </Stack>
      <Divider />
      <Stack direction={"row"} px={3} spacing={2} justifyContent={"center"}>
        <ProductFilters />
        <CreateProductButton />
      </Stack>
      <InventoryDataGrid rows={filteredData} loading={isFetching} />
    </Stack>
  );
};

export default RewardsInventory;
